export default {
  brand: { name: 'POM', tag: '晋级之路', engine: 'POM · PATH OF MASTERS', disclaimer: '差价合约及杠杆交易具有高风险，请充分了解各项规则。' },
  nav: { overview: '概览', leaderboard: '排行榜', route: '晋级路线', accounts: 'MT5 账户', news: '资讯公告', profile: '会员资料', logout: '退出登录' },
  metric: { wallet: '钱包余额', equity: '主账户净值', trades: '交易', edge: 'EDGE分数' },
  round: { n: '第{n}轮', names: ['', '第一轮', '第二轮', '第三轮', '第四轮', '第五轮', '第六轮'] },
  common: {
    loading: '加载中…', retry: '重试', empty: '暂无数据', back: '返回', cancel: '取消', confirm: '确认', save: '保存',
    prev: '上一页', next: '下一页', copy: '复制', copied: '已复制', done: '已完成', submit: '提交', mockHint: '演示数据'
  },
  auth: {
    loginTitle: '登录晋级之路', loginSub: '证明你的交易实力，开启百万交易员之路',
    username: '用户名', usernameOrEmail: '用户名或邮箱', email: '邮箱', password: '密码', passwordConfirm: '确认密码',
    country: '国家/地区', selectCountry: '请选择国家/地区', code: '邮箱验证码', sendCode: '发送验证码', resend: '{s}秒后重发', refId: '推荐码（选填）',
    login: '登录', register: '注册', noAccount: '还没有账户？', toRegister: '立即注册', hasAccount: '已有账户？', toLogin: '去登录',
    registerTitle: '创建账户', registerSub: '注册后即可查看晋级之路资格',
    codeSent: '验证码已发送至您的邮箱', registerOk: '注册成功，请登录',
    err: { required: '请填写{field}', email: '邮箱格式不正确', mismatch: '两次输入的密码不一致', minPwd: '密码至少 6 位' }
  },
  accounts: {
    title: 'MT5 账户', sub: '创建并查看您的 MT5 交易账户',
    create: '开设 MT5 账户', createSub: '选择账户组别与杠杆，提交后立即开户', createBtn: '确认开户', created: '开户成功',
    empty: '您还没有 MT5 账户',
    id: '账号', type: '账户类型', currency: '币种', balance: '余额', credit: '赠金', leverage: '杠杆',
    group: '账户组别', selectGroup: '请选择账户组别', archived: '已归档',
    tabAccounts: '账户', tabTransfer: '转账', tabRecords: '转账记录'
  },
  transfer: {
    sub: '在现金钱包与 MT5 账户之间互相转账',
    in: '转入 MT5', out: '从 MT5 转出至钱包',
    walletBalance: '我的钱包余额', mt5Balance: 'MT5 余额', from: '转出自', to: '转账至', wallet: '现金钱包',
    account: 'MT5 账号', amount: '金额', secPassword: '安全密码', available: '可提取金额', noAccount: '暂无可用的 MT5 账户',
    confirmIn: '确认转账', confirmOut: '确认转出', fillAll: '请填写所有字段', doneIn: '转入成功', doneOut: '转出提交成功'
  },
  records: {
    sub: '现金钱包与 MT5 之间的转账记录',
    toMt5: '转入 MT5 记录', fromMt5: '转出至钱包记录',
    id: 'ID', detail: '详情', amount: '金额 (USD)', time: '时间'
  },
  news: {
    title: '资讯公告', sub: '平台最新资讯与重要公告', tabNews: '资讯', tabNotice: '公告', readMore: '查看详情', unread: '未读', total: '共 {n} 条'
  },
  profile: {
    title: '会员资料', sub: '管理您的个人信息与账户安全',
    info: '基本信息', edit: '修改资料', security: '修改登录密码',
    username: '用户名', fullname: '姓名', email: '邮箱', phone: '手机号码', country: '国家/地区', joined: '注册时间', referrer: '推荐人',
    oldPassword: '当前密码', newPassword: '新密码', newPasswordConfirm: '确认新密码',
    editHint: '修改资料需同时设置登录密码', saved: '保存成功', pwdChanged: '密码修改成功'
  },
  overview: {
    welcome: '欢迎来到晋级之路，挑战你的百万交易员之路',
    welcomeSub: '您已经加入晋级之路，通过交易证明您的实力，正式开启您的百万交易员之路吧。',
    addFunds: '添加资金', tradeNow: '立即交易',
    path: '晋级之路', pathSub: '您迈向交易旅程下一阶段的道路。', viewRoute: '晋级路线',
    joined: '加入晋级之路', passed: '已晋级', target: '当前目标',
    edgeTitle: '您的EDGE分数', edgeBadge: 'AI量化综合评估', edgeScore: 'EDGE 分数', edgeNeed: '{round}需要 {n} 分',
    skill: '技能', risk: '风险', consistency: '一致性', experience: '经验', modelVersion: '算法动态模型版本: {v}', refresh: '每日 08:00 (UTC+8) 刷新',
    qualTitle: '{round}资格', qualSub: '完成以下全部要求即可晋级{round}', qualSubFirst: '完成以下要求即可进入第一轮', reached: '达标',
    promote: '晋级{round}', start: '开启晋级之路',
    reqTrades: '在{round}完成{n}笔独立交易', reqTradesFirst: '完成{n}笔独立交易', reqEdge: 'EDGE 分数 {n}+', reqEquity: '主账户净值最低 {n} USD',
    reqDays: '在{round}停留 {n} 天', reqProfit: '盈利 {n} USD 晋级{round}',
    yourTrades: '您的独立交易', yourEdge: '您的EDGE分数', yourEquity: '您的当前净值', yourDays: '您已停留', yourProfit: '您已盈利', days: '天',
    funded: '配资账户', maxLoss: '最大损失', multiplier: '配资比例', share: '利润分成', viewTrades: '查看交易详情',
    fundedEquity: '配资账户净值', fundedProfit: '配资账户净收益', expectedShare: '预计分配利润', closedOrders: '已完成订单数', openOrders: '进行中订单数',
    curve: '配资账户盈亏曲线', curveSub: '截至当日总盈亏累计', netProfit: '净利润 ($USD)', riskOn: '风控自动化实时监测正常运行中',
    confirmStart: '您确认正式开启第一轮的晋级之路吗？', confirmPromote: '晋级{round}需要将您配资账户进行平仓，您确认要晋级吗？',
    tradeTitle: '开始交易！', tradeSub: '以下是此帐户的MT4详细信息和MT4下载链接。', server: '服务器', login: '登录', downloadMt4: '下载MT4',
    pendingApi: '晋级之路接口对接中，当前为演示数据'
  },
  route: {
    badge: '晋级路线 · TRADER PATH',
    hero1: '欢迎来到晋级之路，', hero2: '发挥您的交易天赋，', hero3: '成为百万交易员',
    heroSub: '经历6个梯级的严格筛选与资本赋能，获得由平台全额注资的高达 1,000,000 美元配资账户，尊享高达 80% 利润分成与顶级交易流动性支持。',
    tableTitle: '晋级资格与阶段权益', unit: '金额单位: USD', criteria: '资格标准',
    minEquity: '主账户最低净值', edge: 'EDGE分数', multiplier: '配资比例', maxDeposit: '最大入金数', share: '利润分成', target: '利润目标',
    days: '阶段时长', trades: '交易笔数', leverage: '配资账号杠杆', maxLoss: '最大损失',
    fundedNote: '(配资账户)', daysNote: '(最低天数)', tradesNote: '(最低笔数)',
    rulesTitle: '晋级规则与风控细则',
    rule1Title: '独立交易规则判定',
    rule1: '每笔交易开仓并平仓后才计为 1 笔独立交易，且同一时间同一品种不能有其他持仓。同时持有同品种的多笔订单均不计入独立交易笔数。',
    rule1Foot: '标准: 以系统撮合时间戳为准',
    rule2Title: '利润结算与提现机制',
    rule2: '晋级下一阶段前需平仓，配资账户盈利按上一阶段利润分成进入钱包，并于下个自然月 1 号可提现。配资账户本身不可提现。',
    rule2Foot: '结算周期: 每月 1 号开放提现',
    rule3Title: '淘汰机制与冷却期约束',
    rule3: '触及最大损失或主账户净值、EDGE 分数不达标即被淘汰。第一轮淘汰无冷却期；其他阶段前两次淘汰经 14 天冷却后回到上一阶段，第三次起需从第一轮重新开始。',
    rule3Foot: '风控判定: 净值与亏损实时监测，EDGE 每日刷新'
  },
  leaderboard: {
    title: '排行榜', live: '实时结算中', top3: '前三名交易员', updated: '数据截至上个自然月',
    distributed: '已分配利润', returnRate: '收益率', equity: '主账户净值', funded: '配资账户额度',
    total: '总排行榜', totalSub: '多轮次综合晋级绩效排名', all: '全部', rank: '排名', trader: '交易员', level: '级别',
    footer: '显示前 {n} 名交易员 · 全网共 {total} 名注册参赛者'
  },
  error: {
    NETWORK_ERROR: '网络连接失败，请稍后重试', SERVER_ERROR: '服务器繁忙，请稍后重试', DUPLICATE_REQUEST: '请求过于频繁，请稍后再试',
    UNAUTHORIZED: '登录已过期，请重新登录', LOGIN_FAIL: '用户名或密码错误', REQUEST_FAILED: '请求失败',
    // 后端接口返回的 message
    'Account Not found': '账户不存在',
    APPROVED: '已批准',
    'Bonus settled': '奖金已结算',
    'code exist': '代码已存在',
    'Connection Error': '连接错误',
    'Deposit Capping': '已达充值上限',
    'Duplicate request detected': '请勿重复提交',
    EMAIL_EXITS: '邮箱已存在',
    FOLLOWING_TRADE: '已在跟单中',
    ibo_return_msg: 'ibo_return_msg',
    'Incorrect current password': '当前密码错误',
    'incorrect email': '邮箱错误',
    'Incorrect ID': 'ID错误',
    'Incorrect package': '配套错误',
    'Incorrect Role': '角色错误',
    'Incorrect User': '用户错误',
    'Incorrect user': '用户错误',
    'Incorrect Username': '用户名错误',
    INCORRECT_ACTION: '操作无效',
    INCORRECT_ADDRESS: '地址错误',
    INCORRECT_BANK: '银行信息错误',
    INCORRECT_EMAIL_FORMAT: '邮箱格式错误',
    INCORRECT_ID: 'ID错误',
    INCORRECT_OTP: '验证码错误',
    Incorrect_otp: '验证码错误',
    INCORRECT_PACKAGE: '配套错误',
    INCORRECT_PASSWORD: '密码错误',
    INCORRECT_SEC_PASSWORD: '安全密码错误',
    INCORRECT_SPONSOR: '推荐人错误',
    INCORRECT_USERNAME: '用户名错误',
    INSUFFICIAN_BALANCE: '余额不足',
    kyc_exist: 'KYC已提交',
    LAST_DEPOSIT_PENDING: '上一笔充值仍在处理中',
    LAST_WITHDRAWAL_PENDING: '上一笔提现仍在处理中',
    Login_OK: '登录成功',
    Logout_OK: '退出成功',
    MEMBER_EXITS: '会员已存在',
    'Min withdraw': '低于最低提现金额',
    'Mt5 Account not found': '找不到MT5账户',
    'Mt5 Account Update Fail': 'MT5账户更新失败',
    'Name exist': '名称已存在',
    NO_PERMISSION: '没有权限',
    OK: '成功',
    'only can upgrade package': '只能升级配套',
    OTP_OK: '验证码验证成功',
    OTP_sent: '验证码已发送',
    'package not active': '配套未激活',
    'package terminated': '配套已终止',
    Password_changed: '密码已修改',
    Password_reset_success: '密码重置成功',
    PENDING: '待处理',
    PLEASE_COMPLETE_KYC: '请先完成KYC认证',
    Register_successful: '注册成功',
    REQUEST_COMPLETE: '操作成功',
    REQUEST_FAIL: '操作失败',
    'sponsor not found': '推荐人不存在',
    Successful: '成功',
    suspend_account: '账户已停用',
    'Updated Successfully': '更新成功',
    'Upload successful': '上传成功',
    'User not exist': '用户不存在',
    'User not found': '用户不存在',
    'User Not found': '用户不存在',
    'User status is updated': '用户状态已更新',
    userFreezed: '账户已冻结',
    'Username already registered': '用户名已被注册',
    'Your BO capital is same with package': '您的BO本金与配套相同',
    '操作失败': '操作失败',
    '操作成功': '操作成功',
    '用户不存在': '用户不存在',
    '钱包不足': '钱包余额不足'
  }
}
